enum ChartTheme {
  BIDS = 'ayudax-bids',
  HS_HISTORICAL_BIDS = 'hs-historical-bids',
  ONE_TONE_BLUE = 'ayudax-one-tone-blue',
  ONE_TONE_GREEN = 'ayudax-one-tone-green',
  ONE_TONE_YELLOW = 'ayudax-one-tone-yellow',
  TWO_TONES = 'ayudax-two-tones',
  THREE_TONES = 'ayudax-three-tones',
  TEN_TONES = 'ayudax-ten-tones',
  TEN_TONES_SITES_NETWORK_PANE = 'ten-tones-sites-network-pane',
}

export default ChartTheme;
